module.exports = __webpack_public_path__ + "static/models/buildings.a51739d.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/sky/buildings.json
// module id = 580
// module chunks = 1